import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import './styles/globals.css'
import App from './App.tsx'
import { AuthCallback } from './components/Auth/AuthCallback.tsx'
import { initializeApp } from './utils/capacitor'

// Inicializar recursos nativos do Capacitor
initializeApp();

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <BrowserRouter>
            <Routes>
                {/* Rotas sem idioma */}
                <Route path="/" element={<App />} />
                <Route path="/auth/callback" element={<AuthCallback />} />

                {/* Rotas com prefixo de idioma (ex: /en/, /es/) */}
                <Route path="/:lang" element={<App />} />
                <Route path="/:lang/*" element={<App />} />
                <Route path="/:lang/auth/callback" element={<AuthCallback />} />

                {/* Fallback para qualquer outra rota */}
                <Route path="*" element={<App />} />
            </Routes>
        </BrowserRouter>
    </StrictMode>,
)

